import './ServiceRequestSettlementQuote.css';
import SettlementQuoteInfo from './SettlementQuoteInfo';

import 'flatpickr/dist/plugins/monthSelect/style.css';
import 'flatpickr/dist/themes/light.css';
import Datepicker from '../../../lib/Datepicker/Datepicker';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {
  getLocalDatePickerFile,
  replaceTranslations,
  serviceRequestPostCall,
} from '../../../utils/util';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import moment from 'moment';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import countrySpecificConfig from './ServiceRequestChangeSettlementQuoteConfig.json';
const ServiceRequestSettlementQuote = (props) => {
  const {t} = useTranslation();
  const [quoteDate, setQuoteDate] = React.useState('');
  const [reasonType, setReasonType] = React.useState(
    'Early settlement due to trade in'
  );
  const [reasonComment, setReasonComment] = React.useState('');
  const [settlementQuoteType, setSettlementQuoteType] =
    React.useState('Full Settlement');
  const [loader, setLoader] = React.useState(false);
  const [settlementInfoEligible, setSettlementInfoEligible] =
    React.useState(false);
  const [automateSettlementInfo, setAutomateSettlementInfo] =
    React.useState(null);
  const [subType, setSubType] = React.useState('');
  const [dateValue, setDateValue] = React.useState('');
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(true);

  const country = props.country;

  const reasonTypesForAllCountries =
    countrySpecificConfig[country]?.reasonTypes;
  const {enqueueToast} = useToastProvider();

  const monthYearPickerOptions = {
    minDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    dateFormat: 'm/Y',
    locale: getLocalDatePickerFile(),
    disableMobile: true,
    plugins: [
      new monthSelectPlugin({
        shorthand: true,
        dateFormat: 'm/Y',
      }),
    ],
    enableTime: false,
    noCalendar: false,
  };

  React.useEffect(() => {
    if (
      settlementQuoteType &&
      settlementQuoteType.length > 0 &&
      quoteDate.length > 0 &&
      reasonType.length > 0
    ) {
      if (reasonType == 'Other - (free text)' && reasonComment.length == 0) {
        setDisableSubmitBtn(true);
      } else {
        setDisableSubmitBtn(false);
      }
    } else {
      setDisableSubmitBtn(true);
    }
  }, [settlementQuoteType, quoteDate, reasonType, reasonComment]);

  const handleContractSubtype = () => {
    let subType = props.contractDetails?.accountDetails[props.contractNumber]
      ?.additionalAccountInformation.isRegulated
      ? 'regulated'
      : 'non_regulated';
    setSubType(subType);
  };

  const checkInfoEligibility = () => {
    setQuoteDate('');
    const eligibleProduct = import.meta.env.VITE_eligibleProduct
      ? import.meta.env.VITE_eligibleProduct.split(',')
      : [];
    const eligibleCountry = import.meta.env.VITE_eligibleCountry
      ? import.meta.env.VITE_eligibleCountry.split(',')
      : [];

    const productLine = props.contractNumbers?.contracts?.find(
      (contract) => contract.contractNumber === props.contractNumber
    )?.productLine;
    if (
      eligibleCountry.includes(props.country) &&
      eligibleProduct.includes(productLine) &&
      !props.contractDetails.accountDetails[props.contractNumber]
        .additionalAccountInformation.isRescheduled &&
      !props.contractDetails.accountDetails[props.contractNumber]
        .additionalAccountInformation.isWithinOneYear &&
      !props.contractDetails.accountDetails[props.contractNumber]
        .additionalAccountInformation.isInArrears
    ) {
      setSettlementInfoEligible(true);
      handleContractSubtype();
    } else {
      setSettlementInfoEligible(false);
    }
  };
  const handleDateChange = (e) => {
    let settlementDate = settlementInfoEligible
      ? moment(e[0], 'MM/YYYY').startOf('month').format('YYYY-MM-DD')
      : moment(e[0]).format('MM/YYYY');
    setQuoteDate(settlementDate);
    setDateValue(e);
    setAutomateSettlementInfo(null);
    if (reasonType !== 'Other - (free text)') setDisableSubmitBtn(false);
  };
  const resetSettlementInfo = () => {
    setQuoteDate('');
    setDateValue(null);
    setAutomateSettlementInfo(null);
  };

  React.useEffect(() => {
    resetSettlementInfo();
    checkInfoEligibility();
    setDisableSubmitBtn(true);
  }, [props.contractNumber]);

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>
        <Button
          disabled={
            settlementInfoEligible
              ? loader || disableSubmitBtn
              : disableSubmitBtn
          }
          id="settlementPrimaryBtn"
          variant="primary"
          onClick={() => settlementSubmitHandler()}
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };
  const settlementSubmitHandler = () => {
    setLoader(true);
    let reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    const accountNumber = props.contractNumbers?.contracts?.find(
      (contract) => contract.contractNumber === props.contractNumber
    )?.accountNumber;
    serviceRequestPostCall(
      {
        contractNumber: props.contractNumber,
        quoteDate,
        quoteReason: reasonType,
        quoteReasonComment: reasonComment,
        requestType: 'Settlement quote',
        settlementQuoteType: settlementQuoteType,
        countryCode: props.country,
        userEmail: props.userDetails.email,
        accountNumber: accountNumber,
        automateSettlementQuote: settlementInfoEligible,
        ...reqBody,
      },
      enqueueToast,
      'SETTLEMENT_QUOTE_SERVICE_REQUEST',
      (res) => {
        setLoader(false);

        if (settlementInfoEligible) {
          setAutomateSettlementInfo(res);
        } else {
          appStore.dispatch(getServiceRequestDetailsAction(null));
          appStore.dispatch(pushViewAction('serviceRequestDashboard'));
        }
      },
      replaceTranslations(t('SERVICE_REQUEST_LIMIT'), 5, t('SETTLEMENT_QUOTE')),
      t('SERVICE_REQUEST_SUCCESS'),
      t('SERVICE_REQUEST_CREATION_FAILED'),
      () => {}
    );
    setDisableSubmitBtn(true);
  };

  return (
    <div className={'ServiceRequestChangePhoneWrapper'}>
      <div className={'ServiceRequestCard'}>
        <div className="serviceRequestHeader">
          <div className={'title'}>{t('SETTLEMENT_QUOTE')}</div>
        </div>
        <div className={'subTitle'}>{t('SETTLEMENT_QUOTE_SUBTITLE')}</div>
      </div>
      <Box pl={4} pr={4} pb={4}>
        <form>
          <Card className="quoteCardCustom ">
            <CardContent className="SettlementQuoteCard">
              <div className={'subTitle'}>
                <Typography gutterBottom variant="h5" required={true}>
                  {t('CHOOSE_SETTLEMENT_TYPE')}
                  <span className="datepicker-asterisk">*</span>
                </Typography>
                <RadioGroup
                  name="group2"
                  data-testid="radio-button-id"
                  className="settlmentType"
                  onClick={(e) => setSettlementQuoteType(e.target.value)}
                >
                  <FormControlLabel
                    control={<Radio checked={true} />}
                    label={t('FULL_SETTLEMENT')}
                    value="Full Settlement"
                  />
                </RadioGroup>
              </div>
              <div className="SettlementQuoteDateContainer">
                <div className="SettlementQuoteDatewrapper">
                  <div id="settlement-datepicker">
                    <Typography gutterBottom variant="h5" required={true}>
                      {t('QUOTE_DATE')}{' '}
                      <span className="datepicker-asterisk">*</span>
                    </Typography>

                    <Datepicker
                      placeholder={'MM / YYYY'}
                      isRequired={true}
                      setDate={(e) => handleDateChange(e)}
                      options={monthYearPickerOptions}
                      value={dateValue}
                    />

                    <div className="quoteDateMsg">{t('QUOTE_DATE_MSG')}</div>
                  </div>
                  <div>
                    {settlementInfoEligible === false ? (
                      <SelectWidget
                        id="settlement-reason"
                        label={t('CALLBACK_REASON')}
                        changeHandler={setReasonType}
                        data={reasonTypesForAllCountries}
                        required={true}
                        defaultValue={reasonType}
                        helperText={t('REASON_HELPER_TEXT')}
                        className={'reasonType'}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="SettlementQuoteDatewrapperSecond">
                  {reasonType == 'Other - (free text)' && (
                    <TextField
                      placeholder={t('REASON_COMMENT_PLACEHOLDER')}
                      className="ChangePhoneTextField"
                      label={t('REASON_COMMENT')}
                      type="number"
                      data-testid="change-phone-number"
                      required={true}
                      value={reasonComment}
                      multiline
                      minRows={3}
                      size="small"
                      onChange={(e) => setReasonComment(e.target.value)}
                    />
                  )}
                </div>

                {settlementInfoEligible ? (
                  <SettlementQuoteInfo
                    show={settlementInfoEligible}
                    selectedContract={props.contractNumber}
                    automateSettlementInfo={automateSettlementInfo}
                    quoteDate={quoteDate}
                    subType={subType}
                  />
                ) : null}
              </div>
            </CardContent>
          </Card>

          {formButtonControls()}
        </form>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    userDetails: state.appStates.userDetailsInfo,
    contractNumbers: state.appStates.contractNumbers,
    contractDetails: state.appStates.contractDetails,
  };
};
export default connect(mapStateToProps)(ServiceRequestSettlementQuote);
